import { useIntl } from "react-intl";
import { Form, Input } from "antd";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { createYupSync } from "@lib/helpers/TableHelper";
import { BillingConfigScanConfig } from "@lib/types/BillingConfig";
import { scanConfigSchema } from "@lib/schemas/billingConfig";
import { ConfigComponentProps } from "../../ConfigComponent";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
};

export default function UsdtScanConfig(
  props: ConfigComponentProps & { tab: string },
) {
  const { config, query, updateQuery } = props;
  const [form] = Form.useForm();
  const { messages } = useIntl();

  const loading = query.isLoading || query.isPending || updateQuery.isPending;

  return (
    <>
      <Form<BillingConfigScanConfig>
        {...layout}
        form={form}
        initialValues={{
          ...config?.data,
        }}
        name={`scan-config-${props?.tab}`}
        onFinish={(values) => {
          updateQuery.mutate({
            id: config.id,
            data: {
              ...values,
            },
          });
        }}
      >
        <Form.Item
          name={["USDT", "scanUrl"]}
          label={messages["common.scanUrl"] as string}
          rules={[createYupSync({ schema: scanConfigSchema })]}
        >
          <Input />
        </Form.Item>
        <StyledFlex style={{ justifyContent: "end" }}>
          <ActionButton type="save" disabled={loading} loading={loading} />
        </StyledFlex>
      </Form>
    </>
  );
}
